import {startsWith} from "lodash/string";

class AnchorComponent extends HTMLElement {
    constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
    }

    connectedCallback() {
        window.addEventListener('scroll', this.handleScroll);
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    isElementInViewport (el) {

        const rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= document.documentElement.clientHeight + (document.querySelector('header').clientHeight * 2) && /* or $(window).height() */
            rect.right <= document.documentElement.clientWidth /* or $(window).width() */
        );
    }

    handleScroll() {
        this.querySelectorAll('ul li a').forEach(anchor => {
            const containerId = anchor.getAttribute('href');
            if( startsWith(containerId, '#') ) {
                const container = document.querySelector(containerId);
                if (container) {
                    if ( this.isElementInViewport(container) ) {
                        anchor.classList.add('active');
                    } else {
                        anchor.classList.remove('active');
                    }
                }
            }
        });
    }
}

customElements.define('anchor-component', AnchorComponent);
